import head from 'lodash/head';
import isEmpty from 'lodash/isEmpty';
import find from 'lodash/find';
import has from 'lodash/has';
import { ACCOUNT_BLOCKED_MESSAGE, EMAIL_ALREADY_VERIFIED } from '../constants/strings';

const UserResponse = (rawResponse) => {
  
  let userData = head(rawResponse);
  let userResponse = {};
  if(isEmpty(userData)) return userResponse;
  const emails = userData.attributes.emails;
  const emailObject = find(emails, (emailObject) =>  { return has(emailObject, 'email') });
  userResponse.email = emailObject ? emailObject.email : '';
  userResponse.emailVerified = emailObject ? emailObject.verified : false;
  userResponse.mobile = userData.attributes.mobile;
  userResponse.id = userData.id;
  userResponse.limitedToken = userData.attributes['limited-token'];
  userResponse.name = userData.attributes['display-name'];
  userResponse.isPasswordSet = userData.attributes['is-password-set'];
  userResponse.isMFAEnabled = userData.attributes['mfa-enabled'];
  userResponse.status = userData.attributes.status;
  userResponse.mobileVerified = userData.attributes['mobile-verified'];
  return userResponse;
};

const userFriendlyErrorMessage = (errorMessage) => {
  if (errorMessage === 'User account is now locked' ||
    errorMessage === 'User account is locked' ||
    errorMessage.match(/user found by [a-z\-0-9]+ is locked./)) {
    return ACCOUNT_BLOCKED_MESSAGE;
  }
  if (errorMessage === 'Otp is incorrect, 1 attempts remaining' ||
    errorMessage.match(/Otp code [0-9]* is incorrect. 1 attempts remaining./)) {
    return 'Last attempt left! If you enter incorrect OTP, your account will be blocked.';
  }
  if (errorMessage === 'Validation failed: Email is verified.' || errorMessage === 'already_verified') {
    return EMAIL_ALREADY_VERIFIED;
  }
  if (errorMessage === 'is verified.') {
    return null;
  }
  return errorMessage;
};

export { UserResponse, userFriendlyErrorMessage }